import React from "react";
import Card from "../../../Home/Components/Card";
import { useNavigate } from "react-router-dom";
import { ReactComponent as AccountIcon } from "../../../Assets/NewIconsForCards/AccountIcon.svg";

const Arr = [
  {
    title: "Account",
    text: "",
    Icon: AccountIcon,
    link: "/AccountOverview",
  },

];

export default function FinancialOverview() {
  const navigate = useNavigate();
  return (
    <div className="mainContainer">
      <div className="overviewCardContainer">
        {Arr.map((record, i) => (
          <Card {...record} key={i} />
        ))}
      </div>
    </div>
  );
}
